// extracted by mini-css-extract-plugin
export default {"page":"bI","wrapper":"cI","text":"eI","icons":"fI","icon":"gI","icon_text":"hI","carousel_wrapper":"iI","slide":"jI","image":"kI","arrows":"lI","prev":"mI","modal_root":"nI","x_mark":"oI","modal":"pI","images":"qI","main_image":"rI","name":"sI"};
    if(module.hot) {
      // 1714422956431
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  